export default __webpack_public_path__ + "static/555-9d27be637653df2f68c2eb654a816a33.gif";